import React, { useState, useEffect } from "react";
import {
  useMediaQuery,
  IconButton,
  TextField,
  Tabs,
  Tab,
  Badge,
  Box,
} from "@mui/material";
import NotificationIconNav from "../../assets/icons/notification.png";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import axiosInstance from "../../helpers/AxiosInstance";
import Popover from "@mui/material/Popover";
import AddShipmentIconSvg from "../styled/AddShipmentIconSvg";
import CreateSingleOrederSvg from "../styled/CreateSingleOrederSvg";
import SchedulePickupSvg from "../styled/SchedulePickupSvg";
import { ButtonsContainer, Notification } from "../utilities";
import Translation from "../utilities/Translation";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../styled/Button";
import CreateBulkOrderSvg from "../styled/CreateBulkOrderSvg";

const NavbarContainer = styled.div`
  position: fixed;
  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  background-color: #fff;

  z-index: 1000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    align-items: center;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 520px;
  min-width: 300px;
  height: 480px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  @media (max-width: 1440px) {
    width: 550px;
  }
  @media (max-width: 425px) {
    min-width: 300px;
  }
`;
const Line = styled.hr`
  border: 1px solid var(--primary-color);
`;

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

const NotificationIcon = styled(IconButton)`
  position: relative;
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 12px;
  height: 12px;
  background-color: red;
  border-radius: 50%;
  display: ${(props) => (props.show ? "block" : "none")};
`;

export default function Navbar({ sideOpen, RoleID }) {
  const { pathname } = useLocation();
  const { t } = useTranslation("layout");
  const { i18n } = useTranslation();
  const matches = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const [anchor, setAnchor] = useState(null);
  const openNotification = Boolean(anchor);
  const handleNotificationClick = (event) => {
    setAnchor(event.currentTarget);
  };
  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [notifications, setNotifications] = useState([]);
  const instance = axiosInstance();
  const { data } = useQuery(
    "notifications",
    async () => {
      const { data } = await instance.get("/GetActiveNotifications");
      return data;
    },
    {
      staleTime: 60000,
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (data) {
      setNotifications(data.notifications);
    }
  }, [data]);
  // حدّد تبويب افتراضي
  const [tab, setTab] = useState("orders");

  // ذكاء بسيط لتصنيف الإشعار حسب النوع/النص
  const categorize = (n) => {
    const type = (n.Type || n.Category || "").toLowerCase();
    const text = `${n.StatusName || ""} ${n.Body || ""}`.toLowerCase();

    if (["order", "orders"].includes(type)) return "orders";
    if (["activity", "account", "account_activity"].includes(type))
      return "activity";
    if (["alert", "alerts", "warning", "error"].includes(type)) return "alerts";

    if (
      /(lost|exception|on hold|issue|problem|cancel|refus|failed|return)/i.test(
        text
      )
    )
      return "alerts";
    if (/(balance|invoice|payment|fee|charge|wallet|account)/i.test(text))
      return "activity";

    return "orders";
  };

  const groupNotifications = (list = []) => {
    const res = { orders: [], activity: [], alerts: [] };
    list.forEach((n, i) => {
      const key = categorize(n);
      res[key].push({ item: n, originalIndex: i });
    });
    return res;
  };

  const grouped = React.useMemo(
    () => groupNotifications(notifications),
    [notifications]
  );
  const current = grouped[tab] || [];
  const top3 = current.slice(0, 3);

  const [anchorCreate, setAnchorCreate] = useState(null);
  const openCreate = Boolean(anchorCreate);
  const handleOpenCreate = (event) => {
    setAnchorCreate(event.currentTarget);
  };
  const handleCloseCreate = () => {
    setAnchorCreate(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchText.trim()) {
      navigate(`/shipment/${searchText}`);
      setSearchText("");
      setShowSearch(false);
    }
  };
  // قبل الـ return أو فوقه مباشرة
  const TOP_OFFSET = matches ? 64 : 76; // عدّلها حسب ارتفاع النافبار عندك
  const centerX = typeof window !== "undefined" ? window.innerWidth / 2 : 0;

  return (
    <NavbarContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            display: matches ? "none" : "flex",
            alignItems: "center",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "4px 8px",
            backgroundColor: "#FFF8F8",
            maxWidth: "400px",
            width: "350px",
          }}
        >
          <IconButton type="submit" sx={{ p: "5px", color: "#999" }}>
            <i className="fas fa-search"></i>
          </IconButton>
          <TextField
            size="small"
            placeholder={t("Navbar.search_placeholder")}
            variant="standard"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              disableUnderline: true,
              sx: { ml: 1, flex: 1 },
            }}
          />
        </form>
      </div>

      <IconsContainer>
        <NotificationIcon onClick={handleNotificationClick}>
          <img src={NotificationIconNav} alt="notification" />
          <NotificationBadge show={notifications.length > 0} />
        </NotificationIcon>
        <Translation />
      </IconsContainer>
      <Button
        style={{
          backgroundColor: "#AE1A1A",
          color: "white",
          width: "250px",
          border: "none",
          boxShadow: "none",
          height: "50px",
          fontSize: "14px",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          gap: "10px",
        }}
        onClick={handleOpenCreate}
      >
        <AddShipmentIconSvg
          style={{ width: 20, height: 20 }}
          stroke="#ffffffff"
        />
        {t("Navbar.create")}
      </Button>

      <Popover
        anchorEl={anchorCreate}
        open={openCreate}
        onClose={handleCloseCreate}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { boxShadow: "0px 6px 20px rgba(0,0,0,.15)", borderRadius: 2 },
        }}
      >
        <div style={{ padding: 12, width: "360px", maxWidth: "90vw" }}>
          {[
            {
              key: "single",
              icon: <CreateSingleOrederSvg style={{ width: 24, height: 24 }} />,
              title: "Create Single Order",
              desc: "create orders one by one",
              to: "/quick-newshipment",
            },
            {
              key: "bulk",
              icon: <CreateBulkOrderSvg style={{ width: 24, height: 24 }} />,
              title: "Create Bulk Orders",
              desc: "upload excel sheet to generate multiple orders at once",
              to: "/upload",
            },
            {
              key: "pickup",
              icon: <SchedulePickupSvg style={{ width: 24, height: 24 }} />,
              title: "Schedule a Pickup",
              desc: "select a date to pickup your orders",
              to: "/new-pickup",
            },
          ].map((opt, idx) => (
            <button
              key={opt.key}
              onClick={() => {
                handleCloseCreate();
                navigate(opt.to);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                width: "100%",
                textAlign: "left",
                border: "1px solid #ddd",
                borderRadius: 14,
                padding: "14px 16px",
                background: "#fff",
                cursor: "pointer",
                marginBottom: idx !== 2 ? 10 : 0,
                boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  display: "grid",
                  placeItems: "center",
                  color: "#AE1A1A",
                }}
              >
                {opt.icon}
              </div>
              <div>
                <div
                  style={{ color: "#AE1A1A", fontWeight: 700, fontSize: 16 }}
                >
                  {opt.title}
                </div>
                <div style={{ color: "#9A9A9A", fontSize: 13 }}>{opt.desc}</div>
              </div>
            </button>
          ))}
        </div>
      </Popover>

      <Popover
        open={openNotification}
        anchorReference="anchorPosition"
        anchorPosition={{ top: TOP_OFFSET, left: centerX }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        // onClick={() => {
        //   setAnchor(null);
        // }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{ fontFamily: "Cairo" }}
      >
        <Card>
          {/* Tabs Header */}
          <Box sx={{ px: 1, pt: 1 }}>
            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              variant="fullWidth"
              sx={{
                "& .MuiTab-root": { textTransform: "none", minHeight: 44 },
                "& .Mui-selected": { fontWeight: 700 },
              }}
            >
              <Tab
                value="orders"
                label={
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <span>{t("Navbar.orders") || "Orders"}</span>
                    <Badge
                      color="error"
                      max={99}
                      badgeContent={grouped.orders.length}
                    />
                  </Box>
                }
              />
              <Tab
                value="activity"
                label={
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <span>
                      {t("Navbar.account_activity") || "Account Activity"}
                    </span>
                    <Badge
                      color="error"
                      max={99}
                      badgeContent={grouped.activity.length}
                    />
                  </Box>
                }
              />
              <Tab
                value="alerts"
                label={
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <span>{t("Navbar.alerts") || "Alerts"}</span>
                    <Badge
                      color="error"
                      max={99}
                      badgeContent={grouped.alerts.length}
                    />
                  </Box>
                }
              />
            </Tabs>
          </Box>

          <Line />

          {/* List Content */}
          <div dir="rtl" style={{ maxHeight: 380, overflowY: "auto" }}>
            {top3.length ? (
              top3.map(({ item, originalIndex }, i) => (
                <React.Fragment key={item.Serial || originalIndex}>
                  <Notification
                    setNotifications={setNotifications}
                    notifications={notifications} // مهم: بنمرّر الآري الأصلية
                    notificationIndex={originalIndex} // الإندكس الأصلي جوه الآري الأصلية
                    AWB={item.AWB}
                    Body={item.Body}
                    Status={item.StatusName}
                    Serial={item.Serial}
                  />
                  {i < top3.length - 1 && <Line />}
                </React.Fragment>
              ))
            ) : (
              <ButtonsContainer
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  fontSize: "18px",
                }}
              >
                {t("Navbar.no_Notification")}
              </ButtonsContainer>
            )}

            {/* Footer */}
            {(grouped[tab] || []).length > 0 && (
              <ButtonsContainer
                style={{ marginTop: "10px", marginBottom: "10px" }}
              >
                <Button to="/notifications" onClick={() => setAnchor(null)}>
                  {t("Navbar.all_notifications")}
                </Button>
              </ButtonsContainer>
            )}
          </div>
        </Card>
      </Popover>
    </NavbarContainer>
  );
}
